import { CommonModule, IMAGE_LOADER, ImageLoaderConfig, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { CollectivityStickerComponent } from '@inshared/shared/ui';
import { HeroHeaderIconComponent } from './hero-header-icon/hero-header-icon.component';
import {
    HeroHeaderComponent,
    HeroHeaderContentDirective,
    HeroTitleAggregateDirective,
    HeroTitleIconDirective,
    HeroTitleTitleDirective,
} from './hero-header.component';

@NgModule({
    imports: [CommonModule, CollectivityStickerComponent, NgOptimizedImage],
    declarations: [
        HeroHeaderComponent,
        HeroTitleIconDirective,
        HeroTitleTitleDirective,
        HeroTitleAggregateDirective,
        HeroHeaderContentDirective,
        HeroHeaderIconComponent,
    ],
    exports: [
        HeroHeaderComponent,
        HeroTitleIconDirective,
        HeroTitleTitleDirective,
        HeroTitleAggregateDirective,
        HeroHeaderContentDirective,
        HeroHeaderIconComponent,
    ],
    providers: [
        {
            provide: IMAGE_LOADER,
            useValue: (config: ImageLoaderConfig): string => {
                if (config.loaderParams?.['srcset'] && config.width) {
                    const srcset: { [key: string]: string } = config.loaderParams?.['srcset'];
                    return srcset[config.width];
                }
                return config.src;
            },
        },
    ],
})
export class HeroHeaderModule {}
